import { AppRouting } from './components/appRouting';

function App() {
    return <AppRouting />;
}

export default App;
